import React, { useEffect } from 'react'
import ReactGA from 'react-ga'
import PropTypes from 'prop-types'
import { toast } from 'react-toastify'
import { useMutation } from 'react-apollo'

import Error from '../Error/Error'
import { ModeRedirect } from '../ModeRouter/ModeRouter'
import { verifyEmail } from './VerifyEmail.graphql'
import { useAuth } from '../AuthProvider/AuthProvider'
import { dataByTypename } from '../../utils/apollo-helpers'
import Checkmark from '../../assets/checkmark.svg'

import './VerifyEmail.css'

const VerifyEmail = ({ onClose }) => {
  const search = new URLSearchParams(location.search)
  const verificationToken = search.get('confirmToken')
  const { authenticate, loading } = useAuth()
  const [mutate, result] = useMutation(verifyEmail, {
    variables: { input: { verificationToken } },
    onError: () => {},
    onCompleted: (data) => {
      if (data) {
        const { AuthenticationResponse } = dataByTypename(
          data.verifyEmail
        )

        if (AuthenticationResponse) {
          const handleInput = {
            variables: {
              input: AuthenticationResponse
            }
          }
          authenticate(handleInput)
          ReactGA.event({
            category: 'User Account',
            action: 'Verify Success',
            nonInteraction: true
          })
          toast(
            <span styleName='toast'>
              <Checkmark styleName='checkmark' />
              Account verified. You're now logged in.
            </span>
          )
          onClose()
        }
      }
    }
  })

  useEffect(() => { mutate() }, [mutate])

  if (loading) return null

  const { data, error, refetch } = result
  if (error) {
    return <Error error={error} retry={refetch} />
  }

  if (data) {
    const { VerifyEmailError } = dataByTypename(data.verifyEmail)
    if (
      VerifyEmailError &&
      VerifyEmailError.code === 'TOKEN_ALREADY_USED'
    ) {
      ReactGA.event({
        category: 'User Account',
        action: 'Verify Failure',
        label: 'Existing Account',
        nonInteraction: true
      })
      return (
        <ModeRedirect
          mode='login'
          state={{ verifyAccountRedirect: true }}
        />
      )
    }
    if (VerifyEmailError) {
      ReactGA.event({
        category: 'User Account',
        action: 'Verify Failure',
        label: 'Token Expired',
        nonInteraction: true
      })
      return (
        <ModeRedirect
          mode='create'
          state={{ expired: true }}
        />
      )
    }
  }
  return null
}

VerifyEmail.propTypes = {
  onClose: PropTypes.func.isRequired
}

export default VerifyEmail
